import { locationsDB, pluckDocs } from '../helpers/db'
import {sortByField, generateLocationId} from '../helpers/utils'

const SAVE_LOCATION_SUCCESS = 'locations/SAVE_LOCATION_SUCCESS'
const SAVE_LOCATION_FAILURE = 'locations/SAVE_LOCATION_FAILURE'
const UPDATE_LOCATION = 'locations/UPDATE_LOCATION'
const UPDATE_INMEMORY_LOCATION = 'locations/UPDATE_INMEMORY_LOCATION'
const CLEAR_INMEMORY_LOCATION = 'locations/CLEAR_INMEMORY_LOCATION'
const CLEAR_SUCCESS_MESSAGE = 'locations/CLEAR_SUCCESS_MESSAGE'
const BATCH_LOCATION_UPDATE = 'locations/BATCH_LOCATION_UPDATE'
const LOCATION_REQUEST_ONGOING = 'locations/LOCATION_REQUEST_ONGOING'
const LOCATION_REQUEST_ENDED = 'locations/LOCATION_REQUEST_ENDED'

const defaultState = {
  locations: [],
  inMemoryLocation: {},
  requestOngoing: false
}
export default (state = defaultState, {type, ...actionProps}) => {
  switch (type) {
    case SAVE_LOCATION_SUCCESS:
      return {
        ...state,
        successMsg: 'Location saved successfully'
      }
    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        successMsg: ''
      }
    case SAVE_LOCATION_FAILURE:
      return {
        ...state,
        error: actionProps.error,
        successMsg: actionProps.error.reason
      }
    case BATCH_LOCATION_UPDATE:
    case UPDATE_LOCATION:
      return {
        ...state,
        locations: [...actionProps.data],
        requestOngoing: false
      }
    case UPDATE_INMEMORY_LOCATION:
      return {
        ...state,
        inMemoryLocation: {...actionProps.data}
      }
    case CLEAR_INMEMORY_LOCATION:
      return {
        ...state,
        inMemoryLocation: {}
      }
    case LOCATION_REQUEST_ONGOING:
      return {
        ...state,
        requestOngoing: true
      }
    case LOCATION_REQUEST_ENDED:
      return {
        ...state,
        requestOngoing: false
      }
    default:
      return {
        ...state
      }
  }
}

/**
 * Reset InMemoryLocation store
 */
export const resetInMemoryLocation = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_INMEMORY_LOCATION
  })
}

/**
 * clear success message, just updating to ''
 */
export const clearSuccessMessage = () => (dispatch, getState) => {
  dispatch({
    type: CLEAR_SUCCESS_MESSAGE
  })
}

/**
 * this is used to update the in memory location, when creating location
 * @param patch updates any field with the patch object
 * @returns {undefined}
 */
export const updateInMemoryLocation = (patch) => (dispatch, getState) => {
  const tempLocation = getState().locations.inMemoryLocation
  dispatch({
    type: UPDATE_INMEMORY_LOCATION,
    data: { ...tempLocation, ...patch }
  })
}

/**
 * This is used to update/create location
 */
export const saveLocation = () => (dispatch, getState) => {
  const locationList = [...getState().locations.locations]

  // dispatch something is going on with the location
  dispatch({
    type: LOCATION_REQUEST_ONGOING
  })

  let inMemoryLocation = Object.assign({}, getState().locations.inMemoryLocation)
  let newLocation = false

  inMemoryLocation.updatedAt = new Date().toISOString()

  // if no id in the inMemoryLocation means its a new one we add id
  if (!inMemoryLocation._id) {
    inMemoryLocation._id = generateLocationId(inMemoryLocation)
    inMemoryLocation.createdAt = new Date().toISOString()

    locationList.push(inMemoryLocation)
    newLocation = true
  } else {
    // else don't push to the list, simply update the locationList with it
    const index = locationList.findIndex(loc => loc._id === inMemoryLocation._id)
    if (index > -1) {
      locationList[index] = inMemoryLocation
      newLocation = false
    }
  }

  const action = {
    type: UPDATE_LOCATION,
    data: sortByField(locationList, 'name')
  }
  locationsDB.put(inMemoryLocation)
    .then((response) => {
      inMemoryLocation._rev = response.rev
      dispatch(action)
      dispatch({
        type: SAVE_LOCATION_SUCCESS
      })
      // clear the inMemoryLocation after saving the newly added location
      if (newLocation) {
        dispatch({
          type: CLEAR_INMEMORY_LOCATION
        })
      }
      dispatch({
        type: LOCATION_REQUEST_ENDED
      })
    })
    .catch((e) => {
      dispatch({
        type: SAVE_LOCATION_FAILURE,
        error: e
      })
      dispatch({
        type: LOCATION_REQUEST_ENDED
      })
    })
}

/**
 * Fetch all theh locations on our location DB
 */
export const fetchLocations = () => (dispatch) => {
  dispatch({
    type: LOCATION_REQUEST_ONGOING
  })
  return locationsDB.allDocs({
    include_docs: true
  })
    .then(pluckDocs)
    .then((locations) => {
      dispatch({
        type: BATCH_LOCATION_UPDATE,
        data: sortByField(locations, 'name')
      })
    })
    .catch(() => {
      dispatch({
        type: LOCATION_REQUEST_ENDED
      })
    })
}



// WEBPACK FOOTER //
// ./src/locations/locations-reducer.js